import {
  UserAction,
  UserType
} from '../actions';

export type UserStateType = {
  isAuthenticated: boolean;
  isAuthenticationInitiated: boolean;
  isLoginInitiated: boolean;
  isLogoutModalShown: boolean;
  userRole: string | null;
};

const initialState: UserStateType = {
  isAuthenticated: false,
  isAuthenticationInitiated: false,
  isLoginInitiated: false,
  isLogoutModalShown: false,
  userRole: null,
};

export const userAuthenticationReducer = (
  state = initialState,
  { type, payload }: UserAction
): UserStateType => {
  switch (type) {
    case UserType.AUTHENTICATE_USER:
    case UserType.INITIALIZE_AUTHENTICATION:
    case UserType.INITIALIZE_LOGIN:
    case UserType.SET_USER_ROLE:
    case UserType.SET_USER_DATA:
    case UserType.SHOW_LOGOUT_MODAL:
    case UserType.HIDE_LOGOUT_MODAL:
      return {
        ...state,
        ...payload, // TODO: Remove payload wrapping in DPGECLOF-41
      };

    default:
      return state;
  }
};
